import React, { useState } from "react";
import NavBar from "./NavBar";
import BrightnessTip from "./Tip"; // renamed to match your code
import ItProjectsLayoutDektop from "../components/ItProjectsLayoutDesktop";
import { useMediaQuery } from "react-responsive";
import ItProjectsLayoutMobile from "../components/ItProjectsLayoutMobile";

const ItProjects = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const [tip1Visible, setTip1Visible] = useState(true);
  const [tip2Visible, setTip2Visible] = useState(true);
   const [tip3Visible, setTip3Visible] = useState(true);
  
  
  const tip1Bottom = (tip2Visible && tip3Visible) ? 170 :
                   (tip2Visible || tip3Visible) ? 90 : 10;

  const tip2Bottom = tip3Visible ? 90 : 10;
  const tip3Bottom = 10;


  const closeTips = () => {
    setTip1Visible(false);
    setTip2Visible(false);
    setTip3Visible(false)
  };

  return (
    <>

    {isMobile ? (
        <>
         <BrightnessTip
        visibility={tip1Visible}
        text={"📢 Click on any card to uncover full details and insights"}
        bottom={tip1Bottom}
        right={10}
        onClose={() => setTip1Visible(false)}
      />

      <BrightnessTip
        visibility={tip2Visible}
          text={
    <span>
  📢 Best experience on desktop (drag and drop).{" "}
  <a href="https://drive.google.com/file/d/1-q9ubn6oZkXiKgzVqTHK3x74lmzhszxE/view?usp=sharing"  className="text-blue-500 underline">
    See tutorial
  </a>.
</span>


  }
        bottom={tip2Bottom}
        right={10}
        onClose={() => setTip2Visible(false)}
      />

      <BrightnessTip
        visibility={tip3Visible}
        text={"📢 The Project 3D View will be available soon."}
        bottom={tip3Bottom}
        right={10}
        onClose={() => setTip3Visible(false)}
      />

        </>
      ) : (
        <>
         

    

      <BrightnessTip
        visibility={tip3Visible}
        text={"📢 The Project 3D View will be available soon."}
        bottom={tip3Bottom}
        right={10}
        onClose={() => setTip3Visible(false)}
      />

        </>
      )}
     
      <NavBar
        links={[
          { type: "anchor", label: "Home", href: "/" },
          { type: "anchor", label: "About", href: "/" },
          { type: "anchor", label: "Certifications", href: "/Certifications" },
          { type: "anchor", label: "Experience", href: "/" },
          { type: "anchor", label: "Services", href: "/" },
          {
            type: "anchor",
            label: "Projects",
            href: "/",
            children: [
              { type: "anchor", label: "Dev Projects", href: "/DevProjects" },
              { type: "anchor", label: "IT Projects", href: "/ItProjects" },
            ],
          },
          { type: "anchor", label: "Products", href: "/Products" },
          { type: "anchor", label: "Contact", href: "/" },
        ]}
      />

      {isMobile ? (
        <ItProjectsLayoutMobile closeTips={closeTips} />
      ) : (
        <ItProjectsLayoutDektop />
      )}
    </>
  );
};

export default ItProjects;
